import React from 'react';

import { DailySummaryContainer } from '../../containers/dailySummary';

export const DailySummary: React.FC = () => <DailySummaryContainer />;
